// src/App.jsx
import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./Components/Navbar";
import Footer from "./Components/Footer";
import Home from "./Pages/Home";
import About from "./Pages/About";
import Shoot from "./Pages/Shoot";
import Contact from "./Pages/Contact";
import ViewStoryDetails from "./Pages/ViewStoryDetails";
import Trailers from "./Pages/Trailers";
import logo from "../src/assets/logo.png";


function SplashScreen({ onFinish }) {
  useEffect(() => {
    const timer = setTimeout(() => {
      onFinish();
    }, 5000); // 5 seconds
    return () => clearTimeout(timer);
  }, [onFinish]);

  return (
    <div style={styles.splashContainer}>
      <h1 style={styles.welcomeText}>WELCOME</h1>
      <img
        src={logo}
        alt="Splash"
        style={styles.splashImage}
      />
    </div>
  );
}

function AppContent() {
  return (
    <>
      <Navbar />
      <div style={{ backgroundColor: "#0d0d0d", minHeight: "100vh" }}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/shoot" element={<Shoot />} />
          <Route path="/shoot/:id" element={<ViewStoryDetails />} />
          <Route path="/trailers" element={<Trailers />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
      </div>
      <Footer />
    </>
  );
}

function App() {
  const [showSplash, setShowSplash] = useState(true);

  return (
    <Router>
      {showSplash ? (
        <SplashScreen onFinish={() => setShowSplash(false)} />
      ) : (
        <AppContent />
      )}
    </Router>
  );
}

const styles = {
  splashContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
    width: "100vw",
    backgroundColor: "#000",
    color: "#fff",
    textAlign: "center",
    overflow: "hidden",
    
  },
welcomeText: {
  fontSize: "2.5rem",
  marginBottom: "1rem",
  fontWeight: "bold",
  fontFamily: "'Poppins', sans-serif",
  opacity: 0,
  animation: "fadeIn 5s ease-in-out",
},
  splashImage: {
    width: "100%",
    height: "auto",
    maxHeight: "80vh",
    objectFit: "cover",
    opacity: 0,
    animation: "fadeIn 5s ease-in-out",
  },
};

export default App;